import { MENU_TYPE_COMPLIANCE_SETUP, MENU_TYPE_GOV_MANAGEMENT_STRUCTURE, MENU_TYPE_GOV_ORG_CHART, MENU_TYPE_GOVERNANCE_SETUP, MENU_TYPE_MANAGE_COMPLAINCE, MENU_TYPE_TRANSFER_BODY } from './MainContainerTypes'

// KEY =  key of object
export const CATEGORIES = 'categories'
export const REGULATORYBODIES = 'regulatorybodies'
export const GOVERNANCE_TYPE_ID_BY_BOARD = 1
export const GOVERNANCE_TYPE_ID_BY_LAW = 2
export const COMPLIANCEFOR = 'complianceFor'
export const COMPLIANCECATEGORIES = 'complianceCategories'
export const SUBCATEGORIES = 'subCategories'
export const FREQUENCIES = 'frequencies'
export const TIMELINE = 'timeline'
export const BINARY_QUESTION_KEY = 'binaryQuestions'
export const FORMS_KEY = 'forms'
export const THRESHOLD_LIMIT_KEY = 'thresholdLimits'
export const CHECKLIST_KEY = 'checkLIst'
export const CATEGORY_KEY = 'category'
export const SUB_CATEGORY_KEY = 'subCategory'
export const MULTI_DEPARTMENTS_KEY = 'deparments'
export const REGULATION_ID_KEY = 'regulationId'
export const COMPLIANCE_FOR_KEY = 'complianceFor'
export const COMPLIANCE_CATEGORY_KEY = 'complainceCategory'
export const DESCRIPTION = 'description'
export const COMPLIANCE_STATUS = 1
export const INTERNAL_CUT_OFF_KEY = 'internalCutoff'
export const PERIOD_KEY = 'period'
export const TIMELINE_KEY = 'timeLine'
export const FREQUENCY_KEY = 'frequency'
export const COMP_INACTIVE_DATE = 'inActiveDate'
export const COMP_CONTROLINDEX = 'complainceControlIndex'
export const COMPLIANCE_TIMELINE_MANUAL = 1
export const COMPLIANCE_TIMELINE_PREDIFINED = 2
export const UOM_PERCENTAGE_ID = 1
export const UOM_NUMBER_ID = 2
export const UOM_AMOUNT_ID = 3
export const BIN_Q_APPLICABLE_ID = 1
export const BIN_Q_NOT_APPLICABLE_ID = 2
export const RACI_ROUTE_COMPLIANCE_EDIT = 'Edit%20compliance'
export const RACI_ROUTE_COMPLIANCE_ADD = 'Add%20compliance'
export const INFORMED_INDEX_RACI = 3
export const CONSULTED_INDEX_RACI = 2
export const INFORMED_RACIID = 4
export const NAVBAR_OF_GOVERNANCE = [
    {
        name: 'Board Member',
        cssCompare: MENU_TYPE_GOV_MANAGEMENT_STRUCTURE,
        type: MENU_TYPE_GOV_MANAGEMENT_STRUCTURE,
        featureName: 'Management Structure',
        parent: 'governance'

    },
    {
        name: 'Manage Org Chart',
        cssCompare: MENU_TYPE_GOV_ORG_CHART,
        type: MENU_TYPE_GOV_ORG_CHART,
        featureName: 'Organization Chart',
        parent: 'governance'
    },
    {
        name: 'Reassign Regulation',
        cssCompare: MENU_TYPE_TRANSFER_BODY,
        type: MENU_TYPE_TRANSFER_BODY,
        featureName: 'Transfer Body',
        parent: 'governance'
    },
    {
        name: 'Governance Setup',
        cssCompare: MENU_TYPE_GOVERNANCE_SETUP,
        type: MENU_TYPE_GOVERNANCE_SETUP,
        featureName: 'Governance Setup',
        parent: 'governance'
    }
]
export const NAVBAR_OF_COMPLIANCE_SETUP = {
    name: 'Compliance Setup',
    cssCompare: MENU_TYPE_COMPLIANCE_SETUP,
    type: MENU_TYPE_COMPLIANCE_SETUP,
    featureName: 'Compliance Setup',
    parent: 'compliance'
}
export const NAVBAR_OF_MANAGE_COMPLIANCE = {
    name: 'Manage Compliance',
    cssCompare: MENU_TYPE_MANAGE_COMPLAINCE,
    type: MENU_TYPE_MANAGE_COMPLAINCE,
    featureName: 'Manage Compliance',
    parent: 'compliance'
}
export const GOVERNANCE_PARENT_NAME = 'governance'
export const COMPLIANCE_PARENT_NAME = 'compliance'
export const INTIAL_INDEX_OF_GOVERNANCE = 0
export const INFORMED_DEPARTMENT = [
    {
        value: -1,
        label: 'Management Structure'
    }
]
export const INFORMED_ROLE = [
    {
        value: -6,
        label: 'Board of Directors'
    }
]
export const editRegulatoryBodyOptions = {
    // Type: {
    //     key: 'typeId',
    //     options:
    //         [
    //             { value: 1, label: 'Mandate by Board' },
    //             { value: 2, label: 'Mandate by Law' }
    //         ]
    // },
    // Duration: {
    //     key: 'durationId',
    //     options: [
    //         { value: 1, label: 'Fixed' }
    //     ]
    // },
    // 'Audit Required': {
    //     key: 'auditId',
    //     options: [
    //         { value: 1, label: 'Optional' }
    //     ]
    // },
    // 'Risk Factors': {
    //     key: 'isRiskFactors',
    //     options:
    //         [
    //             { value: true, label: 'Yes' },
    //             { value: false, label: 'No' }
    //         ]
    // },
    // 'Complaince Factors': {
    //     key: 'isComplianceFactors',
    //     options: [
    //         { value: true, label: 'Yes' },
    //         { value: false, label: 'No' }
    //     ]
    // },
    Status: {
        key: 'status',
        options: [ 'Active', 'In Active' ]
    }

}

export const compLianceControls = [
    {
        controlName: 'Binary Questions',
        controlId: 1,
        isChecked: false
    }, {
        controlName: 'Forms',
        controlId: 2,
        isChecked: false
    }, {
        controlName: 'Threshold Limits',
        Uod: [{ value: '%', label: 'Percentage', limit: 100 }],
        controlId: 3,
        isChecked: false
    }, {
        controlName: 'Checklist',
        controlId: 4,
        isChecked: false
    }
]

export const compFreqOptions = [
    {
        id: 5,
        name: 'Weekly'
    },
    {
        id: 1,
        name: 'Monthly'
    },
    {
        id: 2,
        name: 'Quarterly'
    },
    {
        id: 3,
        name: 'HalfYearly'
    },
    {
        id: 4,
        name: 'Annually'
    },
    {
        id: 6,
        name: 'Event'
    }

]

export const bodyTypes = [
    { value: 'regulatory', label: 'Regulatory' },
    { value: 'standards', label: 'Standards' },
    { value: 'statutory', label: 'Statutory' },
    { value: 'projects', label: 'Projects' }
]

export const lawTypes = [
    { value: '1', label: 'Mandate by Law' },
    { value: '2', label: 'Mandate by Board' }
]

export const regulationTypes = [
    // feature not created
    // { value: 0, label: 'Event based' },
    { value: 5, label: 'Weekly' },
    { value: 1, label: 'Monthly' },
    { value: 2, label: 'Quarterly' },
    { value: 3, label: 'Half-Yearly' },
    { value: 4, label: 'Annual' },
    { value: 6, label: 'Event' }
]

export const regulatoryBodyList = [
    {
        id: 1,
        value: 'Goods and Service Tax (GST)',
        isChecked: false
    },
    {
        id: 2,
        value: 'Securities and Exchange Board of India (SEBI)',
        isChecked: false
    },
    {
        id: 3,
        value: 'Reserve Bank of India (RBI)',
        isChecked: false
    },
    {
        id: 4,
        value: 'Insurance Regulatory and Development Authority of India (IRDAI)',
        isChecked: false
    },
    {
        id: 5,
        value: 'Ministry of Labour and Employment',
        isChecked: false
    }
]

export const complianceData = {
    [CATEGORIES]: [
        { value: 'Category1', label: 'Category 1' },
        { value: 'Category2', label: 'Category 2' },
        { value: 'Category3', label: 'Category 3' }
    ],
    [REGULATORYBODIES]: [
        { value: 'RegulatoryBody1', label: 'Regulatory Body 1' },
        { value: 'RegulatoryBody2', label: 'Regulatory Body 2' },
        { value: 'RegulatoryBody3', label: 'Regulatory Body 3' }
    ],
    [COMPLIANCEFOR]: [
        { value: 'ComplianceFor1', label: 'Compliance For 1' },
        { value: 'ComplianceFor2', label: 'Compliance For 2' },
        { value: 'ComplianceFor3', label: 'Compliance For 3' }
    ],
    [COMPLIANCECATEGORIES]: [
        { value: 'ComplianceCategory1', label: 'Compliance Category 1' },
        { value: 'ComplianceCategory2', label: 'Compliance Category 2' },
        { value: 'ComplianceCategory3', label: 'Compliance Category 3' }
    ],
    [SUBCATEGORIES]: [
        { value: 'SubCategory1', label: 'Subcategory 1' },
        { value: 'SubCategory2', label: 'Subcategory 2' },
        { value: 'SubCategory3', label: 'Subcategory 3' }
    ],
    [FREQUENCIES]: [
        { value: 'month', label: 'Monthly' },
        { value: 'quarter', label: 'Quarterly' },
        { value: 'half', label: 'Half yearly' },
        { value: 'year', label: 'Yearly' }
    ],
    [TIMELINE]: [
        { value: 2, period: 1, label: 'Days before the month end' },
        { value: 1, period: 1, label: 'Days after the month end' },
        { value: 2, period: 2, label: 'Days before the quarter end' },
        { value: 1, period: 2, label: 'Days after the quarter end' },
        { value: 2, period: 3, label: 'Days before the half-year end' },
        { value: 1, period: 3, label: 'Days after the half-year end' },
        { value: 2, period: 4, label: 'Days before the yearly point' },
        { value: 1, period: 4, label: 'Days after the yearly point' }
    ]
}
export const TOTAL_API_HIT_COUNT = 4
export const GOVERNANCE_PARAM = 0
export const REGULATION_PARAM = 1
export const COLUMN_FREQ_TOTAL_IND = 1
export const SETUP = {
    GOVERNANCE: 'Governance',
    COMPLIANCE: 'Compliance'
}
